<template>
  <div v-if="apptemp">
    <TransitionRoot appear :show="showModal" as="template">
      <Dialog as="div" @close="closeModal">
        <div class="fixed inset-0 z-30 overflow-y-auto">
          <div class="min-h-screen text-center flex">
            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0"
              enter-to="opacity-10"
              leave="duration-200 ease-in"
              leave-from="opacity-10"
              leave-to="opacity-0"
            >
              <DialogOverlay class="fixed inset-0 bg-black opacity-30" />
            </TransitionChild>

            <TransitionChild
              as="template"
              enter="duration-300 ease-out"
              enter-from="opacity-0 scale-50"
              enter-to="opacity-100 scale-100"
              leave="duration-200 ease-in"
              leave-from="opacity-100 scale-100"
              leave-to="opacity-0 scale-50"
            >
              <div
                class="inline-block w-full my-5 mx-3 md:w-1/2 md:mx-auto max-w-screen-md m-auto overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded"
              >
                <div class="flex flex-row">
                  <div class="flex-1"></div>
                  <div class="flex-4 pr-2 pt-2 cursor-pointer" @click="closeModal">
                    <XIcon class="text-brand-dark-gray w-7 h-7" ref="close" />
                  </div>
                </div>

                <div class="pb-5 px-5 md:px-8">
                  <h2 class="text-xl text-brand-black">Send application link</h2>

                  <p class="py-2 text-sm">
                    Send potential applicants an email that includes a button linking directly to
                    your application form:
                  </p>

                  <h2 class="text-xl text-brand-black">{{ apptemp.name }}</h2>
                  <p class="text-xs italic text-brand-mid-gray">
                    The form name will not be visible to applicants
                  </p>

                  <div class="flex flex-col md:flex-row md:justify-between py-3">
                    <div class="flex flex-col">
                      <h5>Reports included in the form</h5>
                      <div class="flex flex-row py-1">
                        <div
                          class="rounded-lg inline-block py-1 px-1 my-1 mr-1"
                          v-for="type in apptemp.available_report_sources"
                          :key="`${apptemp.slug}-${type}`"
                          :class="[
                            apptemp.selected_report_sources.includes(type) ||
                            apptemp.selected_report_sources.join(',').includes(type)
                              ? 'bg-brand-background-light-blue'
                              : 'bg-brand-light-gray'
                          ]"
                        >
                          <p
                            :class="[
                              'text-2xs capitalize',
                              apptemp.selected_report_sources.includes(type) ||
                              apptemp.selected_report_sources.join(',').includes(type)
                                ? 'text-brand-blue'
                                : 'text-brand-dark-gray'
                            ]"
                          >
                            {{ type }}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="flex flex-col">
                      <h5>Fees to be paid by applicant</h5>
                      <p class="py-1">${{ apptemp.price }}</p>
                    </div>
                  </div>

                  <div class="flex flex-row py-3">
                    <input
                      id="cc"
                      type="checkbox"
                      class="rounded border-gray-300 text-brand-green focus:ring-brand-green w-4 h-4"
                      v-model="cc"
                    />
                    <label for="cc" class="ml-2 block text-sm">Send me a copy</label>
                  </div>

                  <div class="flex flex-col py-1" v-for="(email, idx) in recipients" :key="idx">
                    <div class="flex items-center w-full justify-between">
                      <label for="email" class="block">
                        Email
                        <span class="text-brand-red">*</span>
                      </label>
                      <div class="flex items-center" v-if="idx !== 0">
                        <XIcon
                          class="w-5 h-5 text-brand-red cursor-pointer"
                          @click="removeApplicant(idx)"
                        />
                      </div>
                    </div>
                    <SingleLineInput
                      type="email"
                      :value="recipients[idx].email"
                      @input="recipients[idx].email = $event.target.value"
                      :required="true"
                    ></SingleLineInput>

                    <div class="flex w-full border-t border-gray-300 h-5 mt-3"></div>
                  </div>

                  <div class="flex items-center mb-5" style="width: 140px">
                    <SecondaryButton @click="addApplicant">
                      <div class="flex flex-row">
                        <div class="flex items-center mr-1">
                          <PlusIcon class="text-brand-green w-4 h-4" />
                        </div>
                        <div class="flex items-center">
                          <p class="text-sm font-normal whitespace-nowrap">Add applicant</p>
                        </div>
                      </div>
                    </SecondaryButton>
                  </div>

                  <div class="flex flex-col">
                    <label for="subject" class="block"> Subject </label>
                    <SingleLineInput
                      id="subject"
                      type="text"
                      placeholder="Rental Application Link"
                      :value="subject"
                      @input="subject = $event.target.value"
                    ></SingleLineInput>
                  </div>

                  <div class="flex flex-col pt-5 pb-3">
                    <label for="customMessage" class="block"> Custom message </label>
                    <MultiLineInput
                      id="customMessage"
                      placeholder="Click the button below to start an application."
                      :value="customMessage"
                      @input="customMessage = $event.target.value"
                    ></MultiLineInput>
                  </div>

                  <div class="flex items-center justify-end" v-if="errorMessage">
                    <p class="text-brand-red">{{ errorMessage }}</p>
                  </div>

                  <div class="flex flex-row md:justify-end py-3">
                    <div class="flex flex-col-reverse mx-auto md:mx-0 md:flex-row">
                      <p class="text-center py-3 cursor-pointer md:pr-10" @click="closeModal">
                        Cancel
                      </p>

                      <div class="w-48">
                        <PrimaryButton
                          @click="sendShare()"
                          :disabled="isApplicationTemplateLoading"
                          :is-loading="isApplicationTemplateLoading"
                          >Send application link
                        </PrimaryButton>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TransitionChild>
          </div>
        </div>
      </Dialog>
    </TransitionRoot>
  </div>
</template>
<script>
import { TransitionRoot, TransitionChild, Dialog, DialogOverlay } from "@headlessui/vue"

import { XIcon, PlusIcon } from "@heroicons/vue/outline"

import { APPLICATION_TEMPLATE_SHARE } from "@/store/types"

import { mapGetters } from "vuex"

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    },
    apptemp: {
      type: Object
    }
  },
  components: {
    TransitionRoot,
    TransitionChild,
    Dialog,
    DialogOverlay,
    XIcon,
    PlusIcon
  },
  computed: {
    ...mapGetters(["isApplicationTemplateLoading"])
  },
  data() {
    return {
      cc: false,
      recipients: [
        {
          email: "",
          phone: ""
        }
      ],
      subject: "",
      customMessage: "",
      showPhoneInput: false,
      phoneNumber: "",
      errorMessage: ""
    }
  },
  methods: {
    resetData() {
      Object.assign(this.$data, {
        cc: false,
        recipients: [
          {
            email: "",
            phone: ""
          }
        ],
        subject: "",
        customMessage: "",
        showPhoneInput: false,
        phoneNumber: ""
      })
    },
    closeModal() {
      this.resetData()
      this.$emit("close")
    },
    addApplicant() {
      this.recipients.push({
        email: "",
        phone: ""
      })
    },
    removeApplicant(idx) {
      this.recipients.splice(idx, 1)
    },
    async sendShare() {
      const { recipients, subject, customMessage, cc } = this

      if (!recipients.every((recipient) => recipient.email && recipient.email.length)) {
        this.errorMessage = "Email is required."

        setTimeout(() => {
          this.errorMessage = ""
        }, 3000)
        return
      }

      if (
        !recipients.every(
          (recipient) =>
            !recipient.showPhoneInput ||
            (recipient.showPhoneInput && recipient.phone && recipient.phone.length)
        )
      ) {
        this.errorMessage = "Phone number is required."
        setTimeout(() => {
          this.errorMessage = ""
        }, 3000)
        return
      }

      try {
        await this.$store.dispatch(APPLICATION_TEMPLATE_SHARE, {
          slug: this.apptemp.slug,
          recipients,
          subject,
          customMessage,
          cc
        })
        this.closeModal()
      } catch (err) {
        console.log(err)
      }
    }
  }
}
</script>
<style scoped></style>
